import styled from "styled-components";

export const ButtonContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
	margin-bottom: 16px;
`;
